import HomeApp from "./_HomeApp";

window.homeApp = new HomeApp();
